import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTypographyCase20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconTypographyCase20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.1 2.5H8.9a1 1 0 0 0-1 1V5h4.2V3.5a1 1 0 0 0-1-1m-4.7 1V5H3.5A2.5 2.5 0 0 0 1 7.5v8A2.5 2.5 0 0 0 3.5 18h13a2.5 2.5 0 0 0 2.5-2.5v-8A2.5 2.5 0 0 0 16.5 5h-2.9V3.5A2.5 2.5 0 0 0 11.1 1H8.9a2.5 2.5 0 0 0-2.5 2.5m5.7 3h4.4a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1zM6.75 8H6v1.997a.75.75 0 0 0 1.5 0V9.5h1.75v4H8.5a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-.75v-4h1.75v.497a.75.75 0 0 0 1.5 0V8z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTypographyCase20);
